import React, { useMemo } from 'react';
import { Box, Platform } from '@staffino/primitive-controls';
import ChoiceTextInput from '../components/choice-text-input';

type Props = {
  name?: string;
  placeholder?: string;
  maxLength?: number;
  disabled?: boolean;
  active?: boolean;
  value?: string;
  onChange?: (value: string) => void;
  onFocus?: () => void;
  onKeyDown?: (event?: any) => void;
};

const ChoiceTextInputControl = React.forwardRef(
  (
    { name, placeholder, maxLength, value, onChange, onFocus, ...rest }: Props,
    ref: React.Ref<HTMLInputElement>,
  ) => {
    const handleChange = useMemo(
      () =>
        Platform.select<(v) => void>({
          default: (event) => onChange?.(event?.target.value),
          native: (val) => onChange?.(val),
        }),
      [onChange],
    );
    return (
      <Box flex={1}>
        <ChoiceTextInput
          ref={ref}
          name={name}
          defaultValue={value}
          placeholder={placeholder}
          maxLength={maxLength}
          onFocus={onFocus}
          onChange={handleChange}
          {...rest}
        />
      </Box>
    );
  },
);

export default ChoiceTextInputControl;
